import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import ElementComponent from '../../../Component/UI/Element';
import { StartAnimation } from '../AnimationHelper';
import { delay } from '../../../Utility/Task/TaskQueue';

const EasingBackOutOvershoot = (k: number) => {
    const s = 5;
    k -= 1;
    return k * k * ((s + 1) * k + s) + 1;
};

export class RateAppShow extends AnimationClip {
    public *execute(gameObject: GameObject): IterableIterator<number> {
        const renderable = gameObject.getComponent(Renderable);
        renderable.visible = true;

        const textHavingFun = gameObject
            .find('main_container/text_having_fun')
            .getComponent(ElementComponent);
        textHavingFun.scale.set(0);

        const stars = gameObject
            .find('main_container/group_stars')
            .children.map(star => star.getComponent(ElementComponent));
        stars.forEach(star => star.scale.set(0));

        StartAnimation(gameObject.find('main_container'), 'HUDIconIdle');

        this.scaleTo(textHavingFun, 1, 500);
        yield* delay(100);

        for (const star of stars) {
            this.scaleTo(star, 1, 500);
            yield* delay(100);
        }

        yield* delay(400);
    }

    private scaleTo(
        element: ElementComponent,
        scale: number,
        duration: number
    ): void {
        const tweenScale = this.getTween(element.scale);
        tweenScale
            .to({ x: scale, y: scale }, duration)
            .easing(EasingBackOutOvershoot)
            .start(this.elapsedTime);
    }
}
